import { type GridProps, Grid as MuiGrid } from '@mui/material';

export const Grid = (props: GridProps) => <MuiGrid {...props} />;
